import { useState } from "react";
import '../Styles/FormMember.css';
export function HouseholdMember({ onDataReceived, title }) {
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [gender, setGender] = useState('Male');
    const [dob, setDob] = useState('');
    // const [month, setMonth] = useState(0);
    // const [day, setDay] = useState(0);
    // const [year, setYear] = useState(1900);
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [occupation, setOccupation] = useState('');
    const [employerName, setEmployerName] = useState('');
    const [error, setError] = useState('*Required field');
    const validateEmail = (emailString) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailString);
    };
    const verifyData = () => {
        
        if (firstName.length === 0) {
            setError('first name must be filled out');
            return false;
        }
        if (firstName.length <= 2) {
            setError('first name must be at least 3 characters long');
            return false;
        }
        if (lastName.length === 0) {
            setError('last name must be filled out');
            return false;
        }
        if (lastName.length <= 2) {
            setError('last name must be at least 3 characters long');
            return false;
        }
        // if (month === 0) {
        //     setError('month must be filled out');
        //     return false;
        // }
        // if (day === 0) {
        //     setError('day must be filled out');
        //     return false;
        // }
        // if (year === 1900) {
        //     setError('year must be filled out');
        //     return false;
        // }
        if (new Date(dob) > new Date()) {
            setError('date of birth must be in the past');
            return false;
        }
        if (new Date().getFullYear() - new Date(dob).getFullYear() < 18) {
            setError('age must be at least 18 years old');
            return false;
        }
        if (phone.length !== 10) {
            setError('phone number must U.S number with 10 digits');
            return false;
        }
        if (email.length === 0) {
            setError('email must be filled out');
            return false;
        }
        if (validateEmail(email) === false) {
            console.log(validateEmail(email));
            setError('email must be match the format');
            return false;
        }
        setError('');
        return true;
        // console.log(firstName, middleName, lastName, dob, phone, email, occupation, employerName);
    }
    const buttonClicked = async (e) => {
        e.preventDefault();
        //check if the form is valid
        const isValid = verifyData();
        console.log('dob', dob);
        if (isValid) {
            const temp = {
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
                gender: gender,
                dob: dob,
                phone: phone,
                email: email,
                occupation: occupation,
                employerName: employerName
            };
            onDataReceived(temp);
            setError('member data assigned successfully');

        }
    }
    return (
        <div>
            <div className='formMemberMainDiv'>
                <div className="nameDiv">
                    <label>{title}</label>
                </div>
            </div>
            <div className="formMemberMainDiv">
                <div className='nameDiv'>
                    <label>First Name*</label><br />
                    <input placeholder='First Name' type='text' onChange={(e) => setFirstName(e.target.value)}
                        value={firstName}></input>
                </div>
                <div className='nameDiv'>
                    <label>Middle Name</label><br />
                    <input placeholder='Middle Name' type='text' onChange={(e) => setMiddleName(e.target.value)}
                        value={middleName}></input>
                </div>
                <div className='nameDiv'>
                    <label>Last Name*</label><br />
                    <input placeholder='Last Name' type='text' onChange={(e) => setLastName(e.target.value)}
                        value={lastName}></input>
                </div>
            </div>
            <div className='formMemberMainDiv'>
                <div className='nameDiv'>
                    <label>Date of birth*</label><br />
                    <input placeholder='Date of Birth' type='date' onChange={(e) => setDob(e.target.value)}
                        value={dob}></input>
                    {/* <select onChange={(e) => setMonth(e.target.value)}>
                        <option value="" disabled selected style={{ color: 'red' }}>Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                    </select> */}
                    {/* <select onChange={(e) => setDay(e.target.value)}>
                        <option value="" disabled selected style={{ color: 'red' }}>Day</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                    </select> */}
                    {/* <select onChange={(e) => setYear(e.target.value)}>
                        <option value="" disabled selected style={{ color: 'red' }}>Year</option>
                        <option value="2007">2007</option>
                        <option value="2006">2006</option>
                        <option value="2005">2005</option>
                        <option value="2004">2004</option>
                        <option value="2003">2003</option>
                        <option value="2002">2002</option>
                        <option value="2001">2001</option>
                        <option value="2000">2000</option>
                        <option value="1999">1999</option>
                        <option value="1998">1998</option>
                        <option value="1997">1997</option>
                        <option value="1996">1996</option>
                        <option value="1995">1995</option>
                        <option value="1994">1994</option>
                        <option value="1993">1993</option>
                        <option value="1992">1992</option>
                        <option value="1991">1991</option>
                        <option value="1990">1990</option>
                        <option value="1989">1989</option>
                        <option value="1988">1988</option>
                        <option value="1987">1987</option>
                        <option value="1986">1986</option>
                        <option value="1985">1985</option>
                        <option value="1984">1984</option>
                        <option value="1983">1983</option>
                        <option value="1982">1982</option>
                        <option value="1981">1981</option>
                        <option value="1980">1980</option>
                        <option value="1979">1979</option>
                        <option value="1978">1978</option>
                        <option value="1977">1977</option>
                        <option value="1976">1976</option>
                        <option value="1975">1975</option>          
                        <option value="1974">1974</option>
                        <option value="1973">1973</option>
                        <option value="1972">1972</option>
                        <option value="1971">1971</option>
                        <option value="1970">1970</option>
                        <option value="1969">1969</option>
                        <option value="1968">1968</option>
                        <option value="1967">1967</option>
                        <option value="1966">1966</option>
                        <option value="1965">1965</option>
                        <option value="1964">1964</option>
                        <option value="1963">1963</option>
                        <option value="1962">1962</option>
                        <option value="1961">1961</option>
                        <option value="1960">1960</option>
                        <option value="1959">1959</option>
                        <option value="1958">1958</option>
                        <option value="1957">1957</option>
                        <option value="1956">1956</option>
                        <option value="1955">1955</option>
                        <option value="1954">1954</option>
                        <option value="1953">1953</option>
                        <option value="1952">1952</option>
                        <option value="1951">1951</option>
                        <option value="1950">1950</option>
                        <option value="1949">1949</option>
                        <option value="1948">1948</option>
                        <option value="1947">1947</option>
                        <option value="1946">1946</option>
                        <option value="1945">1945</option>
                        <option value="1944">1944</option>
                        <option value="1943">1943</option>
                        <option value="1942">1942</option>
                        <option value="1941">1941</option>
                        <option value="1940">1940</option>
                        <option value="1939">1939</option>
                        <option value="1938">1938</option>
                        <option value="1937">1937</option>
                        <option value="1936">1936</option>
                        <option value="1935">1935</option>
                        <option value="1934">1934</option>
                        <option value="1933">1933</option>
                        <option value="1932">1932</option>
                        <option value="1931">1931</option>
                        <option value="1930">1930</option>
                    </select> */}
                </div>
                <div className='nameDiv'>
                    <label>Phone Number*</label><br />
                    <input placeholder='Phone Number' type='number' onChange={(e) => setPhone(e.target.value)}
                        value={phone}></input>
                </div>
                <div className='nameDiv'>
                    <label>Email*</label><br />
                    <input placeholder='Email' type='email' onChange={(e) => setEmail(e.target.value)}
                        value={email}></input>
                </div>
            </div>
            <div className='formMemberMainDiv'>
                <div className='nameDiv'>
                    <label>Gender*</label><br />
                    <select onChange={(e) => setGender(e.target.value)} value={gender}>
                        <option value='Male'>Male</option>
                        <option value='Female'>Female</option>
                    </select>
                </div>
                <div className='nameDiv'>
                    <label>Occupation</label><br />
                    <select onChange={(e) => setOccupation(e.target.value)}>
                        <option value="" disabled selected style={{ color: 'red' }}>Select Occupation</option>
                        <option value="student">Student</option>
                        <option value="fullTime">Full Time</option>
                        <option value="partTime">Part Time</option>
                        <option value="Unemployment">Unemployment</option>
                    </select>
                </div>
                <div className='nameDiv'>
                    <label>Employer Name</label><br />
                    <input placeholder='Employer Name' type='text' onChange={(e) => setEmployerName(e.target.value)}
                        value={employerName}></input>
                </div>
            </div>
            <div className='formMemberMainDiv'>
                <button type='submit' className="submitDiv" onClick={buttonClicked}>Add {title}</button>
                {error && <p className='errorDiv'>{error}</p>}
            </div>
        </div>
    );
}
export function MemberAddress({ onDataReceived, title }) {
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [error, setError] = useState('*Required field');
    const handleAddressLine1Change = (e) => setAddressLine1(e.target.value);
    const handleAddressLine2Change = (e) => setAddressLine2(e.target.value);
    const buttonClicked = (e) => {
        e.preventDefault();
        if (addressLine1 === '') {
            setError('Address Line 1 is required');
            return;
        }
        onDataReceived({
            addressLine1: addressLine1,
            addressLine2: addressLine2
        });
        setError('Address data assigned successfully');
    };
    return (
        <div>
            <div className='formMemberMainDiv'>
                <div className='nameDiv'>
                    <label>{title}</label>
                </div>
            </div>
            <div className='formMemberMainDiv'>
                <div className='nameDiv'>
                    <label>Address Line 1*</label><br />
                    <input placeholder='Address Line 1' type='text' onChange={handleAddressLine1Change}
                        value={addressLine1}></input>
                </div>
                <div className='nameDiv'>
                    <label>Address Line 2</label><br />
                    <input placeholder='Address Line 2' type='text' onChange={handleAddressLine2Change}
                        value={addressLine2}></input>
                </div>
            </div>
            <div className='formMemberMainDiv'>
                <button type='submit' className="submitDiv" onClick={buttonClicked}>Add address</button>
                {error && <p className='errorDiv'>{error}</p>}
            </div>
        </div>
    );
}
